import { BetslipUtilChannels, InternalMessageBusChannels } from "../../dependencies";
var InternalMsgRouter = /** @class */ (function () {
    function InternalMsgRouter(msgBus) {
        var _this = this;
        this.msgBus = msgBus;
        this.listeners = {};
        this.betslipListeners = {};
        Object.keys(BetslipUtilChannels.Listen.Commands).forEach(function (key) {
            _this.listeners[BetslipUtilChannels.Listen.Commands[key]] = key;
        });
        this.betslipListeners[InternalMessageBusChannels.legacy.betslip.items.add] = "selectionAdded";
        this.betslipListeners[InternalMessageBusChannels.legacy.betslip.items.remove] = "selectionRemoved";
    }
    InternalMsgRouter.prototype.attachBetslipListeners = function (onMessageReceived, context) {
        var _this = this;
        Object.keys(this.betslipListeners).forEach(function (x) { return _this.msgBus.on(x, onMessageReceived.bind(context)); });
    };
    InternalMsgRouter.prototype.detachBetslipListeners = function (onMessageReceived, context) {
        var _this = this;
        Object.keys(this.betslipListeners).forEach(function (x) { return _this.msgBus.off(x, onMessageReceived.bind(context)); });
    };
    InternalMsgRouter.prototype.attachListeners = function (onMessageReceived, context) {
        var _this = this;
        Object.keys(this.listeners).forEach(function (x) { return _this.msgBus.on(x, onMessageReceived.bind(context)); });
    };
    InternalMsgRouter.prototype.detachListeners = function (onMessageReceived, context) {
        var _this = this;
        Object.keys(this.listeners).forEach(function (x) { return _this.msgBus.off(x, onMessageReceived.bind(context)); });
    };
    InternalMsgRouter.prototype.sendMessage = function (channel, data) {
        this.msgBus.emit(channel, data);
    };
    return InternalMsgRouter;
}());
export { InternalMsgRouter };
//# sourceMappingURL=InternalMsgRouter.js.map